/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const MeasuredDimension = {
    /**
    * Length
    */
    NUMBER_1: 1,
    /**
    * Thickness
    */
    NUMBER_2: 2,
    /**
    * Gap
    */
    NUMBER_3: 3,
    /**
    * Unknown
    */
    NUMBER_MINUS_1: -1
} as const;
export type MeasuredDimension = typeof MeasuredDimension[keyof typeof MeasuredDimension];


export function instanceOfMeasuredDimension(value: any): boolean {
    for (const key in MeasuredDimension) {
        if (Object.prototype.hasOwnProperty.call(MeasuredDimension, key)) {
            if (MeasuredDimension[key as keyof typeof MeasuredDimension] === value) {
                return true;
            }
        }
    }
    return false;
}

export function MeasuredDimensionFromJSON(json: any): MeasuredDimension {
    return MeasuredDimensionFromJSONTyped(json, false);
}

export function MeasuredDimensionFromJSONTyped(json: any, ignoreDiscriminator: boolean): MeasuredDimension {
    return json as MeasuredDimension;
}

export function MeasuredDimensionToJSON(value?: MeasuredDimension | null): any {
    return value as any;
}

export function MeasuredDimensionToJSONTyped(value: any, ignoreDiscriminator: boolean): MeasuredDimension {
    return value as MeasuredDimension;
}

